import { render, staticRenderFns } from "./FaturaKalem.vue?vue&type=template&id=7d04edb0&"
import script from "./FaturaKalem.vue?vue&type=script&lang=js&"
export * from "./FaturaKalem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports